import { IConfigurationApplicationViewModel } from 'viewModels';
import api from '../services/api/axios';

const getConfigs = () =>
  new Promise<IConfigurationApplicationViewModel>((resolve, reject) => {
    api
      .get(`/tenant/by-request-host`)
      .then(({ data }) => {
        resolve(data);
      })
      .catch(() => reject());
  });

export const TenantController = {
  getConfigs,
};
